<template>
  <div class="current-tool-screen">
    <h1>What do you currently use for transcription?</h1>

    <form
      @submit.prevent="handleSubmit"
      class="login-form"
      :class="{ 'error-active': hasError }"
    >
      <div class="tool-options">
        <div
          v-for="option in toolOptions"
          :key="option.value"
          class="onboarding-option-card"
          :class="{
            selected: preferences.currentTranscriptionTool === option.value,
          }"
          @click.prevent="selectTool(option.value)"
        >
          <div class="onboarding-radio-container">
            <span
              class="onboarding-radio-circle"
              :class="{
                checked: preferences.currentTranscriptionTool === option.value,
              }"
            ></span>
            <span class="onboarding-radio-text">
              <span class="option-title">{{ option.title }}</span>
              <span v-if="option.description" class="option-description">{{
                option.description
              }}</span>
            </span>
          </div>
        </div>
      </div>

      <div v-if="hasError" class="onboarding-form-error">
        <span class="error-icon icon-exclamation-mark"></span>
        <span class="error-txt">{{
          validationErrors.currentTranscriptionTool
        }}</span>
      </div>

      <div class="onboarding-nav-buttons">
        <button
          type="button"
          class="btn btn-secondary"
          @click="$emit('prevStep')"
        >
          Back
        </button>
        <input
          type="submit"
          class="btn btn-primary"
          value="Get Started"
          :disabled="isSubmitting"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { useOnboardingStore } from "@/stores/onboarding-store";
import { mapStores } from "pinia";
import { analytics } from "@/services/analytics.service";

export default {
  name: "CurrentToolScreen",
  computed: {
    ...mapStores(useOnboardingStore),
    preferences() {
      return this.onboardingStore.preferences;
    },
    validationErrors() {
      return this.onboardingStore.validationErrors;
    },
    isSubmitting() {
      return this.onboardingStore.isSubmitting;
    },
    hasError() {
      return !!this.validationErrors.currentTranscriptionTool;
    },
  },
  mounted() {
    // Track step 4 viewed
    analytics.onboardingStep4Viewed();
  },
  data() {
    return {
      toolOptions: [
        {
          value: "NOTHING",
          title: "Nothing / Manual transcription",
          description: "",
        },
        {
          value: "OTTER",
          title: "Otter.ai",
          description: "",
        },
        {
          value: "DESCRIPT",
          title: "Descript",
          description: "",
        },
        {
          value: "BUILTIN_CAPTIONS",
          title: "YouTube / Zoom captions",
          description: "",
        },
        {
          value: "VOICE_MEMOS",
          title: "Phone voice memos",
          description: "",
        },
        {
          value: "OTHER",
          title: "Other",
          description: "",
        },
      ],
    };
  },
  methods: {
    selectTool(value) {
      this.preferences.currentTranscriptionTool = value;

      // Track tool selected
      analytics.onboardingCurrentToolSelected({ tool: value });

      // Clear validation errors
      this.onboardingStore.validationErrors = {};
    },
    handleSubmit() {
      if (this.onboardingStore.validateCurrentStep()) {
        // Track step 4 completed
        analytics.onboardingStep4Completed({
          current_tool: this.preferences.currentTranscriptionTool,
        });

        this.$emit("complete");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.current-tool-screen {
  @include onboarding-screen-title;
}

.tool-options {
  @include onboarding-options-list;
}
</style>
